import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPause = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.11465 4.17518C5.5861 4.27419 5.21415 4.74053 5.19268 5.27783C5.11327 7.26574 5 9.35081 5 11.4999C5 13.6491 5.11327 15.7341 5.19268 17.722C5.21415 18.2594 5.5861 18.7257 6.11465 18.8247C7.3616 19.0583 8.36244 19.0583 9.6094 18.8247C10.1379 18.7257 10.5099 18.2594 10.5314 17.722C10.6108 15.7341 10.724 13.6491 10.724 11.4999C10.724 9.35081 10.6108 7.26574 10.5314 5.27783C10.5099 4.74053 10.1379 4.27419 9.6094 4.17518C8.36244 3.94161 7.3616 3.94161 6.11465 4.17518Z",
		stroke: "currentColor",
		strokeWidth: 1.42857,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.3907 4.17518C14.8622 4.27419 14.4902 4.74053 14.4688 5.27783C14.3893 7.26574 14.2761 9.35081 14.2761 11.4999C14.2761 13.6491 14.3893 15.7341 14.4688 17.722C14.4902 18.2594 14.8622 18.7257 15.3907 18.8247C16.6377 19.0583 17.6385 19.0583 18.8854 18.8247C19.414 18.7257 19.7859 18.2594 19.8074 17.722C19.8869 15.7341 20.0001 13.6491 20.0001 11.4999C20.0001 9.35081 19.8869 7.26574 19.8074 5.27783C19.7859 4.74053 19.414 4.27419 18.8854 4.17518C17.6385 3.94161 16.6377 3.94161 15.3907 4.17518Z",
		stroke: "currentColor",
		strokeWidth: 1.42857,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgPause;
